var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcasting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Finance_Initial-(Desktop)",
    transform: "translate(-875.000000, -543.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45",
    transform: "translate(845.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transactions_Broadcasting",
    transform: "translate(30.000000, 246.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "transparent",
    mask: "url(#mask-2)",
    strokeWidth: 1.6,
    strokeDasharray: "0,0",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.876,9.46777835 L15.752,9.46777835 L17.52,6.80777835 C17.6411262,6.60194207 17.5803524,6.33733498 17.3815514,6.20497819 C17.1827505,6.07262141 16.9151798,6.11862483 16.772,6.30977835 L15.03,8.93177835 L13.23,6.22177835 C13.1454394,6.07808003 12.9883563,5.99291483 12.8217948,6.00046326 C12.6552334,6.00801168 12.5064975,6.10703635 12.4352815,6.25779434 C12.3640654,6.40855232 12.3820434,6.58633035 12.482,6.71977835 L14.308,9.46777835 L7.124,9.46777835 C6.50401215,9.46777737 6.00110318,9.96979148 6,10.5897783 L6,19.3557783 C6,19.6538817 6.11842109,19.9397755 6.32921198,20.1505664 C6.54000287,20.3613573 6.82589667,20.4797783 7.124,20.4797783 L14.55,20.4797783 L14.55,21.8277783 L10.562,21.8277783 C10.3944354,21.8165887 10.2345825,21.8996365 10.147402,22.0431728 C10.0602216,22.1867091 10.0602216,22.3668476 10.147402,22.5103839 C10.2345825,22.6539202 10.3944354,22.736968 10.562,22.7257783 L19.438,22.7257783 C19.6055646,22.736968 19.7654175,22.6539202 19.852598,22.5103839 C19.9397784,22.3668476 19.9397784,22.1867091 19.852598,22.0431728 C19.7654175,21.8996365 19.6055646,21.8165887 19.438,21.8277783 L15.45,21.8277783 L15.45,20.4777783 L22.876,20.4777783 C23.4959878,20.4777793 23.9988968,19.9757652 24,19.3557783 L24,10.5897783 C23.9988968,9.96979148 23.4959878,9.46777737 22.876,9.46777835 Z M23.1,19.3557783 C23.0967481,19.4771408 22.997406,19.5737784 22.876,19.5737784 L7.124,19.5737784 C7.00028822,19.5737784 6.9,19.4734901 6.9,19.3497783 L6.9,10.5897783 C6.90430904,10.4692015 7.00334624,10.3737783 7.124,10.3737783 L22.876,10.3737783 C22.9997118,10.3737783 23.1,10.4740666 23.1,10.5977783 L23.1,19.3557783 Z",
    id: "Shape",
    stroke: "#000000",
    strokeWidth: 0.3,
    fill: "#000000",
    opacity: 0.699999988
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcasting);
export default __webpack_public_path__ + "static/media/broadcasting.8bf1aea50329b06891cc1e9dd762eda9.svg";
export { ForwardRef as ReactComponent };